import React, {useCallback, useContext, useState} from "react";
import FormControl from "@mui/material/FormControl";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import PageContextZiggy from "../../store/page-context-ziggy";

export default function Warehouses(props) {

    const pageCtxZiggy = useContext(PageContextZiggy);
    const [warehouse, setWarehouse] = useState(pageCtxZiggy.warehouse);
    const [warehouses, setWarehouses] = React.useState([]);

    const loadWarehousesFromServer = useCallback(() => {

        axios.get('/config/warehouse').then((response) => {

            const data = [];

            for (const key in response.data) {
                const object = {
                    id: key,
                    ...response.data[key],
                };
                data.push(object);
            }

            setWarehouses(data);

        })

    }, [pageCtxZiggy.warehouse]);

    React.useEffect(() => {
        loadWarehousesFromServer();
    }, [loadWarehousesFromServer]);

    function handleChange(event) {
        setWarehouse(event.target.value);
        pageCtxZiggy.updateWarehouse(event.target.value)
        props.handleChange();
    }

    return <MenuItem>
        <FormControl component="fieldset">
            <FormLabel component="legend">Warehouse</FormLabel>
            <RadioGroup
                aria-label="gender"
                name="controlled-radio-buttons-group"
                value={warehouse}
                onChange={handleChange}
            >
                 <FormControlLabel key={0} value={'All'} control={<Radio/>}
                                      label={'All'}/>
                {warehouses.map(({code, title}, idx) => (
                    <FormControlLabel key={idx} value={code} control={<Radio/>}
                                      label={title}/>
                ))}

            </RadioGroup>
        </FormControl>
    </MenuItem>
}